"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React from "react";

import { cn } from "../../handlers/cn.utils";

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
	<div className="relative h-6 w-6 flex items-center justify-center">
		<CheckboxPrimitive.Root
			ref={ref}
			className={cn(
				"peer h-5 w-5 shrink-0 rounded-xs border border-gray-300 bg-white",
				"hover:border-gray-400",
				"focus:outline-hidden",
				"cursor-pointer",
				"disabled:cursor-not-allowed disabled:opacity-50",
				"data-[state=checked]:bg-primary-500 data-[state=checked]:border-primary-500 data-[state=checked]:text-white",
				"data-[state=checked]:hover:bg-primary-600 data-[state=checked]:hover:border-primary-600",
				"absolute",
				className,
			)}
			{...props}
		>
			<CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
				<Check className="h-4 w-4" />
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	</div>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
